// ensureSessionRoot.js — bind code sessions to an absolute repo path before agent tools run.

import { sessionRoot } from './sessionRoot.js';

const LAST_ROOT_KEY = 'apolo:lastRepoRoot';

function firstAbsolutePath(list) {
  if (!Array.isArray(list)) return '';
  for (const raw of list) {
    const p = typeof raw === 'string' ? raw.trim() : '';
    if (p.startsWith('/')) return p;
  }
  return '';
}

export function hasElectronRepoBridge() {
  return typeof window !== 'undefined' && Boolean(window.apolo?.repo?.detect);
}

/** Persist directory on the session row when we auto-detect ~/Apolo etc. */
export async function ensureSessionRoot(session, { updateSession, fallbackRoots } = {}) {
  const existing = sessionRoot(session);
  if (existing.startsWith('/')) return existing;

  // guard PR #618 (2ª porta, flagrada ao vivo pós-#620): sessão de CHAT sem pasta
  // é ROOTLESS de propósito (F13-E7-T09) — o bind-on-mount re-ligava ~/Apolo por
  // debaixo do guard da criação e o chat voltava a operar no checkout principal.
  // Chat só ganha root por ESCOLHA (picker/@); Code mantém o auto-bind de sempre.
  if (session?.kind === 'chat') return '';

  if (hasElectronRepoBridge()) {
    try {
      const det = await window.apolo.repo.detect();
      if (det?.ok && typeof det.path === 'string' && det.path.startsWith('/')) {
        try { localStorage.setItem(LAST_ROOT_KEY, det.path); } catch { /* noop */ }
        if (updateSession && session?.id) {
          await updateSession(session.id, { directory: det.path });
        }
        return det.path;
      }
    } catch {
      /* detect failed */
    }
  }

  const fallback = firstAbsolutePath(fallbackRoots);
  if (fallback) {
    try { localStorage.setItem(LAST_ROOT_KEY, fallback); } catch { /* noop */ }
    if (updateSession && session?.id) {
      await updateSession(session.id, { directory: fallback });
    }
    return fallback;
  }

  try {
    const cached = localStorage.getItem(LAST_ROOT_KEY);
    if (cached?.startsWith('/')) return cached;
  } catch {
    /* noop */
  }

  return '';
}

export const NO_ROOT_USER_MESSAGE = [
  '⚠️ Esta sessão não tem pasta do projeto vinculada — o agente não consegue usar ferramentas.',
  'Abra Worktree (⇧⌘W) ou crie uma nova sessão; o Apolo deve detectar ~/Apolo automaticamente.',
  'Sem isso, list_files/grep falham com "root is required" e o agente explora seu $HOME.',
].join('\n');
